<ng-template #acceptTosPpDialogTemp>
  <h2 mat-dialog-title class="dialog-title">
    <div class="close-action">
      <button 
        mat-icon-button 
        [matTooltip]="'Close'"
        [matTooltipPosition]="'below'" 
        (click)="closeAcceptTosPpDialog()"
      >
        <mat-icon class="material-icons-outlined text-hint">close</mat-icon>
      </button>
    </div>
  </h2>

  <mat-dialog-content class="dialog-content">
    <div class="mat-headline-6 mb-16">{{generalMessages.TOS_PP_D1_TITLE}}</div>
    <div class="mat-body-2 mb-16">{{generalMessages.TOS_PP_D1_CNT_1}}</div>

    <div class="mb-16">
      <span class="mat-body-2 m-0">{{generalMessages.TOS_PP_D1_CNT_2}}</span>
      <a 
        href="https://gobloominghealth.com/terms-of-service/" 
        target="_blank" 
        class="mat-body-2 text-normal m-0 link-underline"
      >
        Terms of Service
      </a>
      <span class="mat-body-2 m-0"> and </span>
      <a 
        href="https://gobloominghealth.com/privacy-policy/" 
        target="_blank" 
        class="mat-body-2 text-normal m-0 link-underline"
      >
        Privacy Policy
      </a>
      <span class="mat-body-2 m-0">. </span>
    </div>

    <div class="mat-body-2 mb-16">{{generalMessages.TOS_PP_D1_CNT_3}}</div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button 
      mat-button 
      class="mr-16" 
      (click)="closeAcceptTosPpDialog()"
    >
      DECLINE
    </button>
    <button 
      mat-flat-button 
      [mat-dialog-close]="true" 
      color="accent" 
      (click)="closeAcceptTosPpDialog(true)"
    >
      ACCEPT
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #acceptTosPpDeclineDialogTemp>
    <div class="close-action">
        <button 
            mat-icon-button 
            [matTooltip]="'Close'"
            [matTooltipPosition]="'below'" 
            (click)="showAcceptTosPpDialog()"
        >
            <mat-icon class="material-icons-outlined text-hint">close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-column mb-20">
        <div class="mat-headline-6 text-center mb-16">{{generalMessages.TOS_PP_D2_TITLE}}</div>
        <div class="mat-body-2 mb-16">{{generalMessages.TOS_PP_D2_CNT}}</div>
    </div>

    <div class="d-flex align-items-center justify-content-evenly">
        <button 
            mat-button 
            (click)="showAcceptTosPpDialog()"
        >NO, CANCEL</button>
        <button 
            mat-flat-button 
            [mat-dialog-close]="true" 
            color="accent" 
            (click)="forceCloseDialog()"
        >YES, CONFIRM</button>
    </div>
</ng-template>